import { GridModalFormProps, useForm, Validator } from "common";
import I18n from "i18n-js";
import {
  getUserChangePasswordService,
  UserChangePasswordFormItem,
} from "./adminSetupUserChangePasswordApi";

export interface UseUserChangePasswordFormProps extends GridModalFormProps {}

export default function useUserChangePasswordForm({
  id,
  afterSave,
}: UseUserChangePasswordFormProps) {
  const service = getUserChangePasswordService(id);

  const form = useForm<UserChangePasswordFormItem>({
    id: "create",
    ignoreNavigateAfterCreate: true,
    translationCategory: "User",
    rules: {
      password: Validator.rule.any().required(),
    },
    afterSave,
    afterLoad: _newItem => {},
    afterSaveMessage: isCreate => {
      return I18n.t("PasswordChange.successChanged");
    },
    //...service,
    createItem: service.createItem,
  });

  return form;
}
